import React from 'react';
import { Card, Container, Row, Col, Button } from 'react-bootstrap';
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { navigateToLogout } from '../utils/navigation';


const Logout = () => {
    const navigate = useNavigate();
    return (
        <Container
            fluid
            className="vh-100 d-flex justify-content-center align-items-center"
            style={{ position: 'fixed', top: 0, left: 0, zIndex: 9999 }}>
            <Row className="w-100 justify-content-center">
                <Col xs={10} sm={8} md={6} lg={4}>
                    <Card className="text-center">
                        <Card.Body>
                            <br/>
                            <Card.Title>Are you sure you want to logout?</Card.Title>
                            <br/>
                            <div className="d-flex flex-column align-items-center gap-3 mt-4">
                                <Button variant="secondary" onClick={() =>  navigate(-1)} style={{ width: '80%' }}>
                                    Cancel
                                </Button>
                                <Button variant="danger" onClick={() => navigateToLogout()} style={{ width: '80%' }}>
                                    Logout
                                </Button>
                            </div>
                            <br/>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container >
    );
};

export default Logout;